import { connect } from 'react-redux'
import { VzPageContainer } from '../../../layouts/VzPageContainer'
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
} from 'react-bootstrap'
import CustomDataTable from '../../../layouts/DataTables/CustomDataTable'
import ReactSelect from 'react-select'
import { Input } from 'reactstrap'
import { getDropdownList } from '../../Shared/dropdownListActions'
import { useState, useEffect } from 'react'
import { GET_BANKS } from '../../../Types'
import { toast } from 'react-toastify'
import { addBank, deleteBank } from './BanksActions'
import { confirmAlert } from 'react-confirm-alert'
import { AllowOnlyAlpha } from '../../../utilities/Validations'

const Banks = (props) => {
  const [newBank, setNewBank] = useState('')

  const banksColumns = [
    {
      Header: 'Bank Name',
      accessor: 'value',
    },
    {
      Header: 'Action',
      accessor: 'id',
      Cell: (row) => (
        <div>
          <button
            onClick={() => Delete(row.value)}
            className='btn btn-danger'
            style={{ width: 30, height: 30, padding: 3, cursor: 'pointer' }}
          >
            <i className='fa fa-trash'></i>
          </button>
        </div>
      ),
    },
  ]

  const addBank = async () => {
    if (newBank == '' || newBank == null) {
      toast.error('Enter Bank Name')
      return
    }

    let checkIsExist = props.banks.filter(
      (item) =>
        item.value.toUpperCase() === newBank.toUpperCase() ||
        item.value.replace(/ /g, '').trim().toUpperCase() ===
          newBank.replace(/ /g, '').trim().toUpperCase()
    )

    if (checkIsExist.length > 0) {
      toast.warn('Bank with the same name already exist')
      return
    }

    let data = {
      BankName: newBank,
    }
    await props.addBank(data)
    getBanks()

    setNewBank('')
  }

  const getBanks = () => {
    props.getDropdownList(`api/Bank`, GET_BANKS)
  }

  const Delete = (id) => {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <Modal.Dialog>
              <Modal.Header id='customized-dialog-title'>
                <Modal.Title>Confirm to Delete</Modal.Title>
                <button
                  type='button'
                  onClick={() => onClose()}
                  className='btn-close'
                  aria-label='No'
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to delete this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    DeleteRecord(id)
                    onClose()
                  }}
                  variant='outline-primary'
                >
                  Yes, Delete it!
                </Button>
                <Button
                  variant='primary'
                  onClick={onClose}
                  className='btn btn-primary'
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        )
      },
    })
  }

  const DeleteRecord = async (id) => {
    await props.deleteBank(id)
  }

  useEffect(() => {
    getBanks()
  }, [])
  return (
    <div>
      <VzPageContainer title='Banks'>
        <Row>
          <Col md={{ span: 3 }} style={{ float: 'left' }}>
            <h4>
              <b>Banks</b>
            </h4>
          </Col>
        </Row>
        <Row style={{ marginTop: '40px' }}>
          <Col
            xs={12}
            md={{ span: 4, offset: 1 }}
            style={{ marginTop: '80px' }}
          >
            <Row>
              <Col md={12}>
                <Col md={12}>
                  <div className='form-group'>
                    <Input
                      value={newBank}
                      onChange={(name) => setNewBank(AllowOnlyAlpha(name.target.value))}
                      type='text'
                      maxLength={100}
                      placeholder='Enter Bank Name'
                    />
                  </div>
                </Col>
                <Col
                  md={12}
                  style={{ marginTop: '10px', display: 'inline-block' }}
                >
                  <div className='form-group'>
                    <Button
                      className='form-btn'
                      variant='primary'
                      onClick={addBank}
                      style={{ fontSize: 13 }}
                    >
                      Add Bank
                    </Button>
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={{ span: 6, offset: 1 }}>
            <CustomDataTable
              data={props.banks ?? []}
              columns={banksColumns}
              getTrProps= {() => {}}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    banks: state.ddlList.banks,
  }
}

export default connect(mapStateToProps, {
  getDropdownList,
  addBank,
  deleteBank,
})(Banks)
